//axios api
import api from "@/lib/Api";

export const getLandings = async () => {
  try {
    const queryRoute = "/landings";

    const fetchRes = api.axios.get(queryRoute);
    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getLanding = async (id) => {
  try {
    const queryRoute = `/landings/${id}`;

    const fetchRes = api.axios.get(queryRoute);
    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const createLanding = async (formData) => {
  try {
    const queryRoute = `/landings`;

    const fetchRes = api.axios.post(queryRoute, formData);
    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const updateLanding = async (body) => {
  try {
    const queryRoute = `/landings/${body.id}`;

    const fetchRes = api.axios.put(queryRoute, body);
    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const deleteLanding = async (body) => {
  try {
    const queryRoute = `/landings`;

    const fetchRes = api.axios.delete(queryRoute, body);
    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getLandingResponse = async (id) => {
  try {
    const queryRoute = `/landings/${id}/response`;

    const fetchRes = api.axios.get(queryRoute);
    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const fetchAvailableShop = async (landingId) => {
  try {
    const queryRoute = `/landings/${landingId}/availableShop`;

    const fetchRes = api.axios.get(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err);
    console.log(err.message);
    throw err;
  }
};

export const updateLandingResponse = async (landingId, response_id, body) => {
  try {
    const queryRoute = `/landings/${landingId}/response/${response_id}`;

    const fetchRes = api.axios.put(queryRoute, body);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err);
    console.log(err.message);
    throw err;
  }
};

export const getAllLandingByProductId = async (product_id) => {
  try {
    const queryRoute = `/landings/products/${product_id}`;

    const fetchRes = api.axios.get(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getAvailableShopyDateRange = async (start_date, end_date) => {
  try {
    const queryRoute = `/landings/availableShop?start_date=${start_date}&end_date=${end_date}`;

    const fetchRes = api.axios.get(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};
